import fetch from 'common/js/fetch';

// 加载七牛token
export function getQiniuToken() {
  return fetch('/v1/common/get_qiniu_token');
}

// 获取阿里token
export function getAlToken() {
  return fetch('/core/v1/common/public/get_ali_token');
}

// 列表条件查询城市
export function getCityList(config = {}) {
  return new Promise((resolve) => {
    fetch('/core/v1/address/list', config).then((data) => {
      const cityData = [];
      let pObj = {};
      let cList = [];
      let list = [];
      for (let i = 0, len = data.length; i < len; i++) {
        // console.log(len);
        const { id, parentId, levelType } = data[i];
        console.log(levelType, 'levelType');
        if (+levelType === 1) {
          pObj = {
            value: id.toString(),
            parentId: parentId.toString(),
            label: data[i].name,
            children: []
          };
          cityData.push(pObj);
        } else if (+levelType === 2) {
          cList.push({
            value: id.toString(),
            parentId: parentId.toString(),
            label: data[i].name,
            children: []
          });
          // console.log(cityData, 'cityData');
        } else if (+levelType === 3) {
          list.push({
            value: id.toString(),
            parentId: parentId.toString(),
            label: data[i].name
          });
        }
      }
      console.log(cList, 'JSON.stringify(cityData)');
      for (let i = 0, len = cityData.length; i < len; i++) {
        for (let j = 0, cLen = cList.length; j < cLen; j++) {
          if (cityData[i].value === cList[j].parentId) {
            cityData[i].children.push(cList[j]);
          }
        }
      }
      for (let j = 0, cLen = cList.length; j < cLen; j++) {
        for (let k = 0, l = list.length; k < l; k++) {
          if (cList[j].value === list[k].parentId) {
            cList[j].children.push(list[k]);
          }
        }
      }
      sessionStorage.setItem('cityData', JSON.stringify(cityData));
      console.log(cityData, 'JSON.stringify(cityData)');
      resolve(cityData);
    });
  });
}
